document.addEventListener("DOMContentLoaded", () => {

  new Swiper(".luxury-arrivals-slider", {

    slidesPerView: 1,
    spaceBetween: 16,

    navigation: {
      nextEl: ".luxury-swiper-next",
      prevEl: ".luxury-swiper-prev",
    },

    breakpoints: {

      640: {
        slidesPerView: 2,
        spaceBetween: 16,
      },

      768: {
        slidesPerView: 2,
        spaceBetween: 18,
      },

      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },

      1280: {
        slidesPerView: 4,
        spaceBetween: 12,
      }

    }

  });

});